import { useCart } from '@shopify/hydrogen-react';
import { useLocation } from 'react-router-dom';
import { useStoreState } from '../../../store';
import { resolveBackPath } from '../../../utils/collectionBackNavigation';

export function isNavbarHidden(navbar?: string): boolean {
  return navbar === 'false';
}

export function useAppHeaderNav() {
  const location = useLocation();
  const orgId = useStoreState(state => state.orgContext.orgId);
  const collectionHandle = useStoreState(state => state.orgContext.collectionHandle);
  const { lines } = useCart();

  const backPath = resolveBackPath(location, { orgId, collectionHandle });
  const isCollectionPage = location.pathname.startsWith('/collection/');
  const isCartPage = location.pathname === '/cart';
  const showBackLink = Boolean(backPath) && !isCollectionPage;
  const showCart = !isCartPage;
  const cartItemCount = lines?.length ?? 0;

  return {
    backPath,
    cartItemCount,
    isCartPage,
    isCollectionPage,
    showBackLink,
    showCart,
  };
}
